/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
// import MomentUtils from '@date-io/moment';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

import {
  LocalizationProvider as MuiPickersUtilsProvider,
  DatePicker as KeyboardDatePicker,
  TimePicker as KeyboardTimePicker,
  DateTimePicker as KeyboardDateTimePicker,
} from '@mui/x-date-pickers';
import TextField from "../TextField";
import { DateContainer } from './style';

const DateTimePicker = ({
  type,
  variant,
  format,
  margin,
  id,
  label,
  onChange,
  KeyboardButtonProps,
  inputVariant,
  helperText,
  ampm,
  value,
  disableToolbar,
  ...props
}) => {
  if (type === 'date') {
    return (
      <DateContainer id={id}>
        <MuiPickersUtilsProvider id={id} dateAdapter={AdapterDateFns} >
          <KeyboardDatePicker
            disableToolbar={disableToolbar}
            variant={variant}
            inputFormat={format}
            margin={margin}
            id={id}
            name={id}
            label={label}
            value={value}
            onChange={onChange}
            inputVariant={inputVariant}
            KeyboardButtonProps={KeyboardButtonProps}
            {...props}
            renderInput={(params) => (
              <TextField
                sx={{
                  svg: { color: 'primary.main' },
                }}
                helperText={helperText}
                {...params}
              />
            )}
          />
        </MuiPickersUtilsProvider>
      </DateContainer>
    );
  }
  if (type === 'time') {
    return (
      <DateContainer id={id}>
        <MuiPickersUtilsProvider id={id} dateAdapter={AdapterDateFns} >
          <KeyboardTimePicker
            disableToolbar={disableToolbar}
            variant={variant}
            margin={margin}
            id={id}
            label={label}
            value={value}
            inputVariant={inputVariant}
            KeyboardButtonProps={KeyboardButtonProps}
            ampmInClock={ampm}
            {...props}
            onChange={onChange}
            inputFormat={format}
            renderInput={(params) => <TextField {...params} helperText={helperText} />}
          />
        </MuiPickersUtilsProvider>
      </DateContainer>
    );
  }
  return (
    <DateContainer id={id}>
      <MuiPickersUtilsProvider id={id} dateAdapter={AdapterDateFns} >
        <KeyboardDateTimePicker
          disableToolbar={disableToolbar}
          variant={variant}
          inputFormat={format}
          margin={margin}
          id={id}
          label={label}
          value={value}
          onChange={onChange}
          inputVariant={inputVariant}
          KeyboardButtonProps={KeyboardButtonProps}
          ampm={ampm}
          {...props}
          renderInput={(params) => <TextField {...params} helperText={helperText} />}
        />
      </MuiPickersUtilsProvider>
    </DateContainer>
  );
};

DateTimePicker.propTypes = {
  inputVariant: PropTypes.string,
  disableToolbar: PropTypes.bool,
};

DateTimePicker.defaultProps = {
  inputVariant: 'outlined',
  disableToolbar: false,
};

export default DateTimePicker;
